import { combineReducers } from 'redux';

import alert from './alert';
import loader from './loader';
import breadcrumb from './breadcrumb';

import auth from './auth';
import dashboard from './dashboard';
import sucursales from './sucursales';
import empleados from './empleados';
import proveedores from './proveedores';
import gastos from './gastos';
import eventos from './eventos';
import usuarios from './usuarios';
import metodos from './metodos';
import configuracion from './configuracion';
import ventas from './ventas';
import vueltas from './vueltas';
import pagos from './pagos';
import cortes from './cortes';
import nominas from './nominas';
import revisiones from './revisiones';

export default combineReducers({
    alert, loader, breadcrumb, auth, dashboard,
    sucursales, empleados, proveedores, gastos,
    eventos, ventas, vueltas, pagos, cortes, nominas, revisiones, usuarios, metodos, configuracion
});